import { ConnectionType } from '@/store/devices/utils'

export interface DeviceTableRow {
  isOwned: boolean
  spsEol: boolean
  isConnected: boolean
  connectionType: string
  rssi: number
  deviceErrors: string[]
  sensorErrors: string[]
}

export const sortDeviceCondition = (deviceA: DeviceTableRow, deviceB: DeviceTableRow): number => {
  // sort based on isOwned if either are shared
  if (!deviceA.isOwned) {
    return 1
  } else if (!deviceB.isOwned) {
    return -1
  }

  // sort on eol warning if either device has one
  if (deviceA.spsEol) {
    return -1
  } else if (deviceB.spsEol) {
    return 1
  }

  // sort on sps30/tiber status
  const numberErrors = {
    a: countNumberOfErrors(deviceA),
    b: countNumberOfErrors(deviceB)
  }

  // sort on # of errors, unless they have the same #
  if (numberErrors.a !== numberErrors.b) {
    return numberErrors.a > numberErrors.b ? 1 : -1
  }

  // sort based on connection
  if (!deviceA.isConnected) {
    return 1
  } else if (!deviceB.isConnected) {
    return -1
  }

  // sort on device connection type
  if (deviceA.connectionType === ConnectionType.ETHERNET) {
    return 1
  } else if (deviceB.connectionType === ConnectionType.ETHERNET) {
    return -1
  }

  // otherwise sort on rssi
  return deviceA.rssi > deviceB.rssi ? -1 : 1
}

/**
 * Each sensor has a status array with list of strings for the errors if there are any.
 * @returns The total number of device and sensor errors
 */
export const countNumberOfErrors = (device: DeviceTableRow): number => {
  return device.deviceErrors.length + device.sensorErrors.length
}
